import {Injectable} from '@angular/core';
import * as AddressActions from './address.actions';
import {map, mergeMap} from 'rxjs/operators';
import {AddressPartialState} from './address.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {DataPersistence, withCorrelationIdOf} from '@kion/ngrx-helper';
import {Address} from '@kion/data-models';
import * as BasketsActions from "../../../../data-access-baskets/src/lib/+state/baskets.actions";
import {AddressConnectors} from "./address.connectors";

@Injectable()
export class AddressEffects {
  createAddress$ = createEffect(() =>
    this.dataPersistence.fetch(
      AddressActions.createAddress,
      {
        run: (
          action: ReturnType<typeof AddressActions.createAddress>
        ) => {
          if (action.isInvoice) {
            return this.backend.createInvoiceAddress(action.address, action.basketId, action.userId).pipe(
              mergeMap(
                (response: Address) => [
                  withCorrelationIdOf(
                    action,
                    AddressActions.createAddressSuccess({address: response})
                  ),
                  withCorrelationIdOf(
                    action,
                    BasketsActions.loadById({basketId: action.basketId})
                  )
                ]
              )
            );
          }
          return this.backend.createDeliveryAddress(action.address, action.basketId, action.userId).pipe(
            mergeMap(
              (response: Address) => [
                withCorrelationIdOf(
                  action,
                  AddressActions.createAddressSuccess({address: response})
                ),
                withCorrelationIdOf(
                  action,
                  BasketsActions.loadById({basketId: action.basketId})
                )
              ]
            )
          );
        },
        onError: (
          action: ReturnType<typeof AddressActions.createAddress>,
          error
        ) => {
          return withCorrelationIdOf(
            action,
            AddressActions.createAddressError({error: error})
          );
        }
      }
    )
  );
  updateAddress$ = createEffect(() =>
    this.dataPersistence.fetch(
      AddressActions.updateAddress,
      {
        run: (
          action: ReturnType<typeof AddressActions.updateAddress>
        ) => {
          return this.backend.updateAddress(action.addressId, action.address, action.userId).pipe(
            map(
              (response: Address) => withCorrelationIdOf(
                action,
                AddressActions.updateAddressSuccess({address: response})
              )
            )
          );
        },
        onError: (
          action: ReturnType<typeof AddressActions.updateAddress>,
          error
        ) => {
          return withCorrelationIdOf(
            action,
            AddressActions.updateAddressError({error: error})
          );
        }
      }
    )
  );
  loadAll$ = createEffect(() =>
    this.dataPersistence.fetch(
      AddressActions.loadAll,
      {
        run: (
          action: ReturnType<typeof AddressActions.loadAll>
        ) => {
          return this.backend.loadAll().pipe(
            map(
              response => withCorrelationIdOf(action, AddressActions.loadAllSuccess({addresses: response}))
            )
          )
        },
        onError: (
          action: ReturnType<typeof AddressActions.loadAll>,
          error
        ) => {
          return withCorrelationIdOf(
            action,
            AddressActions.loadAllError({error: error})
          );
        }
      }
    )
  );
  clearAddress$ = createEffect(() =>
    this.dataPersistence.fetch(
      AddressActions.clearAddresses,
      {
        run: (
          action: ReturnType<typeof AddressActions.clearAddresses>
        ) => withCorrelationIdOf(action, AddressActions.clearAddressesSuccess()),
        onError: (
          action: ReturnType<typeof AddressActions.clearAddresses>
        ) => withCorrelationIdOf(action, AddressActions.clearAddressesError())
      }
    )
  )

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<AddressPartialState>,
    private backend: AddressConnectors
  ) {
  }

}

